import { ExecSyncOptionsWithBufferEncoding } from 'child_process';

export class PriceQueueUpdateModel {
  approverTypeId: number;
  idProposal: number;
  judgment: boolean;
  cpfCnpj:String;
}